export default __webpack_public_path__ + "img/equipments-expert-banner0.asset.0fe6a95e.jpg";